import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/modules/pos-general/client-area/layout/layout.module';
import { VoucherGeneratorLayoutModule } from 'app/modules/voucher-generator/layout/layout.module';
import { PhotoboothLayoutModule } from 'app/modules/pos-photobooth/client-area/layout/layout.module';
import { ItsLayoutModule } from 'app/modules/pos-its/client-area/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { IonRouterOutlet, IonicModule } from '@ionic/angular';
import { AwesomeCordovaNativePlugin } from '@awesome-cordova-plugins/core';
import { AlertController, IonicRouteStrategy } from '@ionic/angular';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions';
const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [

        BrowserModule,
        BrowserAnimationsModule,
        IonicModule.forRoot(),
        RouterModule.forRoot(appRoutes, routerConfig),

        // Core module of your application
        CoreModule,
        // Layout module of your application (for client-area)
        LayoutModule,
        // Layout module for voucher generator
        VoucherGeneratorLayoutModule,
        // Layout module for photobooth
        PhotoboothLayoutModule,
        // Layout module for ITS theme park
        ItsLayoutModule,
    ],
    providers: [
        AwesomeCordovaNativePlugin,
        AlertController,
        IonRouterOutlet,
        {
            provide: [
                AndroidPermissions
            ],
            useClass: IonicRouteStrategy
        }
    ],
    bootstrap: [
        AppComponent
    ],

})
export class AppModule {
}
